import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormError from './FormError';
import SelectField from './SelectField';
import Timer from './Timer/Timer';

const createOptions = (user, sub) => {
  if (!sub || !user) return [];

  let options = [];

  if (sub.mdn) {
    options.push(['sub_mdn', `Subscription MDN: ${sub.mdn}`]);
  }
  if (user.phone_number) {
    options.push([
      'user_profile_mdn',
      `User profile MDN: ${user.phone_number}`,
    ]);
  }
  if (user.email) {
    options.push([
      'user_profile_email',
      `User profile email address: ${user.email}`,
    ]);
  }

  return options;
};

let SendVerificationCodeForm = ({
  handleSubmit,
  error,
  isSuccess,
  user,
  sub,
  timerTime,
  sendingCode,
  changeSelectedMethod,
  onTimerEnd,
}) => {
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Field
          component={SelectField}
          name="target_method"
          label="Method*"
          options={createOptions(user, sub)}
          empty="-- Select target method --"
          onChange={changeSelectedMethod}
        />
        {timerTime && (
          <p>
            Resending code will be available in{' '}
            <Timer seconds={timerTime} onEnd={onTimerEnd} />
          </p>
        )}
        {error && <FormError error={error} />}
        {isSuccess && <p className="text-success">Code sent successfully</p>}
        <button className="btn btn-primary" disabled={timerTime || sendingCode}>
          Send Verification Code
        </button>
      </form>
    </div>
  );
};

const validate = (values) => {
  let errors = {};

  if (!values.target_method) {
    errors.target_method = 'Required';
  }

  return errors;
};

SendVerificationCodeForm = reduxForm({
  form: 'sendVerificationCode',
  validate,
})(SendVerificationCodeForm);

export default SendVerificationCodeForm;
